import React from 'react';
import styled from 'styled-components';
import Color from '../colors';

const StyledLink = styled.span`
    color: ${Color.SECONDARY};
    text-decoration: none;
    cursor: pointer;
    
    :active {
        color: #002679;
    }
    
    :hover {
        color: #002679;
    }
`;

export default {
    pathParams: 'launch',
    animation: 'launch',
    headline: 'Разработка',
    headlineSmall: 'Разработка',
    isDescComponent: true,
    services: [],
    description: ({ handleChangePage }) => (
        <>
            {'Разрабатываем онлайн-спецпроекты и\u00A0сложные цифровые решения: полезные интернет-сервисы, удобные мобильные приложения, массовые медиа-проекты.'}
            {'\nНаши компетенции в\u00A0'}
            <StyledLink onClick={() => handleChangePage('/direction/research')}>исследованиях</StyledLink>
            {' и\u00A0'}
            <StyledLink onClick={() => handleChangePage('/direction/design')}>проектировании</StyledLink>
            {' '}
            позволяют реализовывать IT-проекты полного цикла
        </>
    ),
};
